import React, { useEffect, useRef } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import {
  FaPlusCircle,
  FaMinusCircle,
  FaPlus,
  FaUndo,
  FaSave,
} from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { getCountrySlice } from "../../../store/slices/countrySlice";
import { getStateSlice } from "../../../store/slices/state";
import { getDistricSlice } from "../../../store/slices/districtSlice";
import { getCitySlice } from "../../../store/slices/citySlice";
import InputText from "../../common/Input/InputText";
import InputDate from "../../common/Input/InputDate";
import styles from "./pharmaSettlement.module.scss";
import { set } from "date-fns";
import { getSupplierSlice } from "../../../store/slices/supplierSlice";
import AsyncSelect from "react-select/async";
import { getAllStockSlice } from "../../../store/slices/stockInventorySlice";
const AddUpdatePharmaSettlement = ({
  showModal,
  setShowModal,
  handleAddUpdate,
  isMode,
  handleSelectChange,
  state,
  medicines,
  settlementFormData,
  setSettlementFormData,
  handlePlaceChange,
  modalAction,
  setSettlementStatus,
  setSettlementReason,
  supplier,
  handleChange,
}) => {
  const [showResult, setShowResult] = useState(true);
  const [medicineRows, setMedicineRows] = useState([
    {
      medicine: null,
      quantity: "",
      totalQuantity: "",
      mrp: "",
      rmrp: "",
      taxable: "",
      cgst: "",
      sgst: "",
      discount: "",
      discountValue: "",
      total: "",
      stockId: "",
      batchNumber: "",
      expiryDate: "",
    },
  ]);
  const [netTotal, setNetTotal] = useState("0.00");
  const [fieldErrors, setFieldErrors] = useState({});
  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    phNumber: false,
    passport: false,
    aadhar: false,
  });
  const [generatedId, setGeneratedId] = useState("");
  const searchInputRef = useRef(null);
  const searchResultRef = useRef(null);
  const { users } = useSelector((state) => state.users);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { userInfo, token } = useSelector((state) => state.auth);
  const { districts } = useSelector((state) => state.district);
  const { cities } = useSelector((state) => state.city);
  const { Country } = useSelector((state) => state.country);
  // const { state } = useSelector((state) => state.state);
  const dispatch = useDispatch();

  const clinicId = clinicInfo?.[0]?.clinicId;
  const firstCharOfClinicName = clinicInfo[0]?.clinicName
    .substring(0, 3)
    .toUpperCase();
  const generateSettlementId = () => {
    const now = new Date();
    const month = now
      .toLocaleString("default", { month: "short" })
      .slice(0, 2)
      .toUpperCase();
    const year = now.getFullYear().toString().slice(-2);
    const randomDigits = Math.floor(1000 + Math.random() * 9000);
    return `${firstCharOfClinicName}${year}${month}${randomDigits}`;
  };

  useEffect(() => {
    dispatch(getCountrySlice({ status: ["Active"], token }));
  }, [dispatch, token]);

  useEffect(() => {
    if (showModal && modalAction === "create") {
      setMedicineRows([
        {
          medicine: null,
          quantity: "",
          totalQuantity: "",
          mrp: "",
          rmrp: "",
          discount: "",
          discountValue: "",
          taxable: "",
          cgst: "",
          sgst: "",
          total: "",
          stockId: "",
          batchNumber: "",
          expiryDate: "",
        },
      ]);
      setNetTotal("0.00");
      const newId = generateSettlementId();
      setGeneratedId(newId);
      setSettlementFormData({
        supplierId: "",
        supplierName: "",
        prescribedBy: "",
        placeOfSupply: "",
        placeOfSupplyName: "",
        settlementStatus: "Pending",
        settlementId: newId,
      });
    }
  }, [showModal, modalAction]);

  const handleMedicineChange = (selectedOption, index) => {
    const selectedMedicine = medicines.find(
      (med) => med._id === selectedOption.value,
    );

    const updatedRows = [...medicineRows];
    updatedRows[index].medicine = selectedOption;
    updatedRows[index].stockId = selectedOption?.value || "";
    updatedRows[index].mrp = selectedMedicine?.mrp || "";
    updatedRows[index].rmrp = selectedMedicine?.rmrp || "";
    updatedRows[index].batchNumber = selectedMedicine?.batchNumber || "";
    updatedRows[index].expiryDate = selectedMedicine?.expiryDate || "";
    updatedRows[index].taxRate = selectedMedicine?.taxRate || "";

    const qty = parseFloat(updatedRows[index]?.quantity) || 0;
    const discount = parseFloat(updatedRows[index]?.discount) || 0;
    const rmrp = parseFloat(updatedRows[index]?.rmrp) || 0;
    const mrp = parseFloat(updatedRows[index]?.mrp) || 0;
    const taxRate = parseFloat(updatedRows[index]?.taxRate) || 0;

    const gross = qty * (mrp === 0 || undefined ? rmrp : mrp);

    const discountAmount = (gross * discount) / 100;
    const taxable = gross - discountAmount;

    const taxAmount = (gross - discountAmount) * (taxRate / 100);
    const cgst = taxAmount / 2;
    const sgst = taxAmount / 2;
    const total = taxable + cgst + sgst;

    updatedRows[index].discountValue = discountAmount.toFixed(2);
    updatedRows[index].cgst = cgst.toFixed(2);
    updatedRows[index].sgst = sgst.toFixed(2);
    updatedRows[index].taxable = taxable.toFixed(2);
    updatedRows[index].total = total.toFixed(2);

    setMedicineRows(updatedRows);
  };

  const handleFieldChange = (index, field, value) => {
    const updatedRows = [...medicineRows];
    updatedRows[index][field] = value;

    const qty = parseFloat(updatedRows[index]?.quantity) || 0;
    const rmrp = parseFloat(updatedRows[index]?.rmrp) || 0;
    const margin = parseFloat(updatedRows[index]?.margin) || 0;
    const discount = parseFloat(updatedRows[index]?.discount) || 0;
    const taxRate = parseFloat(updatedRows[index]?.taxRate) || 0;

    /* ---------- TOTAL CALCULATION ---------- */
    if (field === "quantity" || field === "discount") {
      const mrp = parseFloat(updatedRows[index]?.mrp) || 0;
      const rmrp = parseFloat(updatedRows[index]?.rmrp) || 0;

      const gross = qty * (mrp === 0 || undefined ? rmrp : mrp);
      const discountAmount = (gross * discount) / 100;
      const taxable = gross - discountAmount;

      const taxAmount = (gross - discountAmount) * (taxRate / 100);
      const cgst = taxAmount / 2;
      const sgst = taxAmount / 2;
      const total = taxable + cgst + sgst;

      updatedRows[index].cgst = cgst.toFixed(2);
      updatedRows[index].sgst = sgst.toFixed(2);
      updatedRows[index].taxable = taxable.toFixed(2);
      updatedRows[index].discountValue = discountAmount.toFixed(2);
      updatedRows[index].total = total.toFixed(2);
    }

    setMedicineRows(updatedRows);
  };

  const addMedicineRow = () => {
    setMedicineRows([
      ...medicineRows,
      {
        medicine: null,
        quantity: "",
        totalQuantity: "",
        mrp: "",
        rmrp: "",
        cgst: "",
        sgst: "",
        taxable: "",
        discount: "",
        discountValue: "",
        total: "",
        stockId: "",
        batchNumber: "",
        expiryDate: "",
      },
    ]);
  };

  const removeMedicineRow = (index) => {
    const updatedRows = medicineRows?.filter((_, i) => i !== index);
    setMedicineRows(updatedRows);
  };

  const calculateSubtotal = () => {
    return medicineRows?.reduce((acc, row) => {
      const total = parseFloat(row?.total) || 0;
      return acc + total;
    }, 0);
  };

  useEffect(() => {
    if (
      modalAction === "edit" ||
      (modalAction === "refund" &&
        settlementFormData?.items?.length > 0 &&
        medicines?.length)
    ) {
      const transformedRows = settlementFormData?.items?.map((item) => {
        const med = medicines?.find((m) => m?._id === item.stockId?._id);

        return {
          medicine: med
            ? { value: med?._id, label: med?.name }
            : {
                value: item?.stockId?._id || "",
                label: item?.stockId?.name || "Unknown",
              },
          stockId: item?.stockId || "",
          quantity: item?.quantity || "",
          mrp: med?.mrp || "",
          rmrp: med?.rmrp || "",
          cgst: item?.cgst || "",
          sgst: item?.sgst || "",
          taxable: item?.taxable || "",
          total: item?.total || "",
          discount: item?.discount || "",
          batchNumber: item?.batchNumber || "",
          expiryDate: item?.expiryDate || "",
        };
      });

      setMedicineRows(transformedRows);
      setNetTotal(settlementFormData?.afterDiscount || "");
    }
  }, [modalAction, settlementFormData, medicines]);

  const loadSupplierOptions = async (inputValue) => {
    const response = await dispatch(
      getSupplierSlice({
        clinicId,
        token,
        name: inputValue,
        limit: 10,
        currentPage: 1,
      }),
    );

    const data = response?.payload?.result?.list || [];

    return data.map((item) => ({
      value: item._id,
      label: item.name,
    }));
  };

  const loadMedicineOptions = async (inputValue) => {
    const response = await dispatch(
      getAllStockSlice({
        clinicId,
        token,
        search: inputValue,
        // limit: 10,
        // currentPage: 1,
      }),
    );

    const data = response?.payload?.result?.list || [];

    return data
      .filter((item) => item.quantity > 0)
      .map((item) => ({
        value: item._id,
        label: `${item.name} (${item.quantity})`,
      }));
  };
  return (
    <>
      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        fullscreen
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {modalAction === "edit" || modalAction === "refund"
              ? "UPDATE SETTLEMENT"
              : "ADD SETTLEMENT"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleAddUpdate({
                medicineRows,
              });
            }}
          >
            <div className="row">
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Supplier Name</label>
                  <AsyncSelect
                    cacheOptions
                    loadOptions={loadSupplierOptions}
                    defaultOptions
                    value={
                      settlementFormData?.supplierName
                        ? {
                            value: settlementFormData?.supplier,
                            label: settlementFormData?.supplierName,
                          }
                        : null
                    }
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "supplier")
                    }
                    placeholder="Select Supplier"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Place Of Supply</label>
                  <Select
                    name="placeOfSupply"
                    value={
                      settlementFormData?.placeOfSupply
                        ? {
                            value: settlementFormData?.placeOfSupply,
                            label: settlementFormData?.placeOfSupplyName,
                          }
                        : null
                    }
                    placeholder="Select Place"
                    onChange={(selectedOption) =>
                      handlePlaceChange(selectedOption, "placeOfSupply")
                    }
                    options={state?.map((item) => ({
                      value: item?._id,
                      label: item?.gstCode
                        ? `${item?.gstCode} - ${item?.name}`
                        : `${item?.name}`,
                    }))}
                    isDisabled={
                      modalAction === "edit" || modalAction === "refund"
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label d-block">
                    Settlement Status
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="settlementStatus"
                      id="Pending"
                      value="Pending"
                      checked={
                        settlementFormData?.settlementStatus === "Pending"
                      }
                      onChange={(e) => setSettlementStatus(e?.target?.value)}
                    />
                    <label className="form-check-label" htmlFor="Pending">
                      Pending
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="settlementStatus"
                      id="Settled"
                      value="Settled"
                      checked={
                        settlementFormData?.settlementStatus === "Settled"
                      }
                      onChange={(e) => setSettlementStatus(e?.target?.value)}
                    />
                    <label className="form-check-label" htmlFor="Settled">
                      Settled
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-4">
                  <div className="form-group position-relative">
                    <InputText
                      name="settlementId"
                      value={
                        modalAction === "edit"
                          ? settlementFormData?.settlementId
                          : generatedId
                      }
                      onChange={handleChange}
                      label="Settlement Id"
                      placeholder={"Enter Settlement Id"}
                    />
                  </div>
                </div>

                <div className="col-xl-4">
                  <div className="form-group position-relative">
                    <InputDate
                      name="settlementDate"
                      value={settlementFormData?.settlementDate}
                      onChange={(e) => handleChange(e, "settlementDate")}
                      placeholder="Settlement Date"
                    />
                  </div>
                </div>
                <div className="col-xl-4">
                  <div className="form-group">
                    <label className="col-form-label d-block">
                      Settlement Reason
                    </label>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="settlementReason"
                        id="Expired"
                        value="Expired"
                        checked={
                          settlementFormData?.settlementReason === "Expired"
                        }
                        onChange={(e) => setSettlementReason(e?.target?.value)}
                      />
                      <label className="form-check-label" htmlFor="Expired">
                        Expired
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="settlementReason"
                        id="Damaged"
                        value="Damaged"
                        checked={
                          settlementFormData?.settlementReason === "Damaged"
                        }
                        onChange={(e) => setSettlementReason(e?.target?.value)}
                      />
                      <label className="form-check-label" htmlFor="Damaged">
                        Damaged
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="settlementReason"
                        id="Excess Stock"
                        value="Excess Stock"
                        checked={
                          settlementFormData?.settlementReason ===
                          "Excess Stock"
                        }
                        onChange={(e) => setSettlementReason(e?.target?.value)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="Excess Stock"
                      >
                        Excess Stock
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="settlementReason"
                        id="Others"
                        value="Others"
                        checked={
                          settlementFormData?.settlementReason === "Others"
                        }
                        onChange={(e) => setSettlementReason(e?.target?.value)}
                      />
                      <label className="form-check-label" htmlFor="Others">
                        Others
                      </label>
                    </div>
                  </div>
                </div>
                {/* )} */}
              </div>

              <div className="mt-4">
                <h6>Medicines</h6>
                <div className={styles.pharmaTableWrapper}>
                  <table className="table table-bordered align-middle">
                    <thead className="table-light">
                      <tr>
                        <th
                          style={{
                            width: modalAction === "refund" ? "15%" : "15%",
                          }}
                        >
                          Name
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          Batch No.
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "5%" : "5%",
                          }}
                        >
                          Exp Dt
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          Qty
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          MRP
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          RMRP
                        </th>

                        <th
                          style={{
                            width: modalAction === "refund" ? "6%" : "6%",
                          }}
                        >
                          Disc(%)
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "7%" : "7%",
                          }}
                        >
                          Taxable
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "6%" : "6%",
                          }}
                        >
                          CGST
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "6%" : "6%",
                          }}
                        >
                          SGST
                        </th>
                        <th
                          style={{
                            width: modalAction === "refund" ? "11%" : "11%",
                          }}
                        >
                          Total
                        </th>
                        {modalAction === "refund" && (
                          <th style={{ width: "7%" }}>Refund Status</th>
                        )}
                        {modalAction !== "edit" && (
                          <th style={{ width: "7%" }}>Action</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {medicineRows?.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadMedicineOptions}
                              defaultOptions
                              value={row?.medicine}
                              onChange={(option) =>
                                handleMedicineChange(option, index)
                              }
                              placeholder="Select Medicine"
                              isDisabled={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Batch No."
                              value={row?.batchNumber}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "batchNumber",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="date"
                              className="form-control"
                              placeholder="Exp Dt"
                              value={row?.expiryDate?.split("T")[0]}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "expiryDate",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Qty"
                              value={row?.quantity}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "quantity",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="MRP"
                              value={row?.mrp}
                              readOnly // optional to prevent manual changes
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="RMRP"
                              value={row?.rmrp}
                              readOnly // optional to prevent manual changes
                            />
                          </td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Disc(%)"
                              value={row?.discount}
                              onChange={(e) =>
                                handleFieldChange(
                                  index,
                                  "discount",
                                  e?.target?.value,
                                )
                              }
                              readOnly={
                                modalAction === "edit" ||
                                modalAction === "refund"
                                  ? true
                                  : false
                              }
                            />
                          </td>
                          <input type="hidden" value={row?.discountValue} />
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row?.taxable}
                              readOnly
                            />
                          </td>
                          <input type="hidden" value={row?.taxRate} />
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row?.cgst}
                              readOnly
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row?.sgst}
                              readOnly
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row?.total}
                              readOnly
                            />
                          </td>

                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">
                              {medicineRows?.length > 1 &&
                                modalAction !== "edit" &&
                                modalAction !== "refund" && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => removeMedicineRow(index)}
                                  >
                                    <FaMinusCircle />
                                  </button>
                                )}
                              {index === medicineRows?.length - 1 &&
                                modalAction !== "edit" &&
                                modalAction !== "refund" && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-success"
                                    onClick={addMedicineRow}
                                  >
                                    <FaPlusCircle />
                                  </button>
                                )}
                              {medicineRows?.length >= 1 &&
                                modalAction === "refund" && (
                                  <button
                                    type="button"
                                    className={`btn btn-sm ${
                                      row?.isRefundEditing
                                        ? "btn-success"
                                        : "btn-warning"
                                    }`}
                                    disabled={row?.refundStatus === "Returned"}
                                  >
                                    {row?.isRefundEditing &&
                                    row?.refundStatus !== "Returned" ? (
                                      <FaSave />
                                    ) : (
                                      <FaUndo />
                                    )}
                                  </button>
                                )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="row justify-content-end mt-3">
                  <div className="col-md-3">
                    <div className="mb-2">
                      <label className="fw-bold">Subtotal:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={calculateSubtotal().toFixed(2)}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={settlementFormData?.isAlreadyPaid === true}
              >
                {modalAction === "edit" || modalAction === "refund"
                  ? "Update"
                  : "Add"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AddUpdatePharmaSettlement;
